import { render, staticRenderFns } from "./amountSelectProuctInfo.vue?vue&type=template&id=32f89522"
import script from "./amountSelectProuctInfo.vue?vue&type=script&lang=js"
export * from "./amountSelectProuctInfo.vue?vue&type=script&lang=js"
import style0 from "./amountSelectProuctInfo.vue?vue&type=style&index=0&id=32f89522&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports